window.$ = window.jQuery;
// import Router from "./utils/Router";

//Globals scripts
import globals from "./globals";

// Country plugins
import "../../country-plugin/main";

// Globals
import "../../partials/components/globals";

// Sliders
import "../../partials/components/sliders";
// Accordions
import "../../partials/components/accordions";
// Maps
import "../../partials/components/maps";
// Timeline
import "../../partials/components/timelines";
// Video
import "../../partials/components/videos";
// Blocks
import "../../partials/components/blocks";
// Multistep Form
import "../../partials/components/multistep-attribute/index";
// Gallery
import "../../partials/components/galleries";
// Presentation
import "../../partials/components/presentation";
// Popups
import "../../partials/components/popups";

// heads
// import "../../partials/components/heads";

// Lazy
// import "../js/lazy/Paroller/paroller";
import "../js/lazy/LoadAnimate/load-animate";

// new Router([
//   // {
//   //   attribute: ".swiper-container",
//   //   instance: Swiper,
//   // },
//   // {
//   //   attribute: ".page-storia",
//   //   instance: Storia,
//   // },
//   // {
//   //   attribute: ".testo-home",
//   //   instance: Testo,
//   // },
//   // {
//   //   attribute: ".scroll-reveal",
//   //   instance: "ScrollMagic/scrollmagic-reveal.js",
//   //   fn: () => {},
//   // },
// ]).watch();

import Rellax from "rellax";

var rellax = new Rellax(".rellax", {
  center: true,
});
var rellaxShop = new Rellax(".rellax-shop", {
  center: false,
});

window.onload = function () {
  jQuery(".presentation-category__img-wrapper").addClass("loaded");
  rellax.refresh();
  rellaxShop.refresh();
};

// Gestione form salesforce
{
  let currentForm,
    currentFormId,
    fieldIds = {},
    formIdsToHandle = [
      "CF5fbb8a6e43f6e", // form contatti italiano
      "CF5fbb8a6e43f6e_1", // form contatti italiano
      "CF6001819cbdca6", // form contact inglese
      "CF6001819cbdca6_1", // form contact inglese
      "CF63cb226ca6553", // form pasticceria italiano
      "CF63cb226ca6553_1", // form pasticceria italiano,

      // Newsletter
      "CF63b31ceec2cec", // form newsletter italiano
      "CF63b31ceec2cec_1", // form newsletter italiano
      "CF63b322b059cbd", // form newlsetter greco
      "CF63b322b059cbd_1", // form newlsetter greco
      "CF63b320cea553a", // form newsletter inglese
      "CF63b320cea553a_1", // form newsletter inglese
    ];

  const mappedFormUrl = {
    CF5fbb8a6e43f6e_1: "https://go.pardot.com/l/1009152/2023-01-20/4g1fm8", // contatti italiano
    CF6001819cbdca6_1: "https://go.pardot.com/l/1009152/2023-01-20/4g1fm8", // contatti inglese
    CF63cb226ca6553_1: "https://go.pardot.com/l/1009152/2023-01-20/4g1fmg", // pasticceria italiano
    CF63b31ceec2cec_1: "https://go.pardot.com/l/1009152/2023-05-24/4grjf5", //newsletter italiano
    CF63b322b059cbd_1: "https://go.pardot.com/l/1009152/2023-05-24/4grjf5", //newsletter greco
    CF63b320cea553a_1: "https://go.pardot.com/l/1009152/2023-05-24/4grjf5", //newsletter inglese
  };

  const mappedFields = {
    fld_6886526_1: "nome",
    fld_1080516_1: "cognome",
    fld_7814848_1: "email",
    fld_6979448_1: "telefono",
    fld_2665569_1: "regione",
    fld_1872389_1: "provincia",
    fld_3851264_1: "citta",
    fld_7153161_1: "privacy",
    fld_4356155_1: "messaggio",
    fld_7561974_1: "tipologia",
    fld_4450813_1: "stato", // campo italiano
    fld_2291732_1: "attivita", // campo italiano
    fld_7724367_1: "stato", // campo inglese
    fld_5590055_1: "attivita", // campo inglese
    fld_7724367_1: "stato", // campo greco
    fld_5590055_1: "attivita", // campo greco

    // newsletter tutte le lingue
    fld_8768091_1: "nome",
    fld_9970286_1: "cognome",
    fld_6009157_1: "email",
    fld_1793107_1: "telefono",
    fld_2533101_1: "occupazione",
    fld_5368024_1: "privacy",
    fld_8215724_1: "stato", // stato italiano corporate
    fld_5207244_1: "stato", // stato greco corporate
    fld_6886335_1: "stato", // stato inglese corporate
    fld_8697816_1: "stato", // stato italiano ecommerce
    fld_4391203_1: "stato", // stato inglese ecommerce
    fld_6983638_1: "stato", // stato greco ecommerce
  };

  jQuery(document).on("cf.form.init", function (event, data) {
    /**
     The object in the variable data has the following keys:
         //idAttr - The form's ID attribute
         idAttr: form_id,
         //formId - The forms's ID
         formId: formId,
         //state -the form's state object
         state: state,
         //fieldIds the ids of all field
         fieldIds: CFFIELD_CONFIG[instance].fields.hasOwnProperty('ids') ? CFFIELD_CONFIG[instance].fields.ids : []
     */
    if (formIdsToHandle.includes(data.formId)) {
      fieldIds[data.idAttr] = data.fieldIds;
      fieldIds[data.formId] = data.fieldIds;
    }
  });

  jQuery(document)
    // Before all requests
    .on("cf.ajax.request", function (event, obj) {
      currentForm = obj.$form;
      currentFormId = obj.formIdAttr;
    })
    // Choose one of the following event methods.
    // After all requests, requires checking the response status is complete. Limited ties to form, no ability to check which instance of a form was used if more than one exists on the page.
    .on("cf.submission", function (event, obj) {
      // Only if status of request is complete|success.
      if ("complete" === obj.data.status || "success" === obj.data.status) {
        // Form contatti
        if (formIdsToHandle.includes(currentFormId)) {
          if (window.cfstate.hasOwnProperty(currentFormId)) {
            var state = window.cfstate[currentFormId];

            const data = {};

            fieldIds[currentFormId]?.forEach((fieldId) => {
              const key = mappedFields[fieldId]
                ? mappedFields[fieldId]
                : fieldId;

              const val = state.getState(fieldId);

              if (val) data[key] = val;
            });

            delete data["fld_1338129_1"];

            $.ajax({
              url: mappedFormUrl[currentFormId],
              dataType: "text",
              type: "post",
              contentType: "application/x-www-form-urlencoded",
              data: data,
              success: function (data, textStatus, jQxhr) {
                console.log(data, textStatus);
              },
              error: function (jqXhr, textStatus, errorThrown) {
                console.log(errorThrown);
              },
            });
          }
        }
      }
    })
    // Only after complete request (globally, no ties to the form itself).
    .on("cf.complete", function () {
      // console.log("completed", currentForm, currentFormId);
    });
}
